import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { AppProps } from 'next/app';
import { ThemeProvider } from 'react-jss';
import React from 'react';

import { initTranslation } from '../i18n';
import { dsoTheme } from '../theme';

function Page({ Component, pageProps: { lang = 'en', ...props } }: AppProps) {
  if (i18n.locale !== lang) {
    initTranslation({ i18n, locale: lang });
  }

  React.useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentElement) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);
  return (
    <ThemeProvider theme={dsoTheme}>
      <I18nProvider i18n={i18n}>
        <Component {...props} />
      </I18nProvider>
    </ThemeProvider>
  );
}

export default Page;
